module.exports = __webpack_public_path__ + "static/media/gnb-03_white_gift.f91d8e6d.svg";